import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Clock, ArrowRight } from 'lucide-react';
export function Offer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const handleBuy = () => {
    window.location.href = 'https://checkout.ebookpoint.shop/cart/59622612959313:1';
  };
  return <section id="comprar" className="py-20 px-4 bg-[#f8f9fa]" data-id="element-70">
      <div className="max-w-2xl mx-auto text-center" data-id="element-71">
        <motion.h2 initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-4xl md:text-6xl text-[#1a3d1f] mb-6 uppercase" data-id="element-72">
          Destacar empieza por entender la posición.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white border-2 border-[#84cc16]/40 rounded-2xl p-6 mb-6 text-left shadow-sm" data-id="element-73">
          <p className="text-[#1a3d1f] font-bold uppercase text-lg mb-3 text-center" style={{
          fontFamily: 'Anton, sans-serif'
        }} data-id="element-74">
            🎁 Comprando HOY también te llevás:
          </p>
          <ul className="space-y-2" data-id="element-75">
            {['Calculadora de proteínas', 'Calculadora de hidratación', 'Psicología Deportiva', 'Tabla de validación científica sobre suplementos'].map((item, i) => <li key={i} className="flex items-center gap-2 text-gray-700" data-id="element-76">
                <span className="text-[#84cc16] font-bold" data-id="element-77">✓</span>
                <span data-id="element-78">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <div className="bg-white p-8 rounded-2xl shadow-xl border-2 border-[#84cc16]" data-id="element-79">
          <div className="flex items-center justify-center text-[#1a3d1f] font-bold mb-6 gap-2" data-id="element-80">
            <Clock className="w-5 h-5" data-id="element-81" />
            <span data-id="element-82">
              LA OFERTA TERMINA EN: {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>

          <div className="mb-6" data-id="element-83">
            <p className="text-gray-500 line-through text-2xl mb-2" data-id="element-84">
              Precio normal: $55.900
            </p>
            <div className="flex items-center justify-center gap-4" data-id="element-85">
              <span className="text-6xl font-bold text-[#1a3d1f]" style={{
              fontFamily: 'Anton, sans-serif'
            }} data-id="element-86">
                $19.990
              </span>
              <span className="bg-[#84cc16] text-[#1a3d1f] font-bold px-3 py-1 rounded-full text-sm uppercase" data-id="element-87">
                ARS
              </span>
            </div>
          </div>

          <div className="bg-[#f8f9fa] rounded-xl p-5 mb-6 text-left border border-gray-100" data-id="element-88">
            <p className="font-bold text-[#1a3d1f] mb-3 text-center uppercase" style={{
            fontFamily: 'Anton, sans-serif'
          }} data-id="element-89">
              Esto es todo lo que te llevás hoy:
            </p>
            <ul className="space-y-2 text-gray-700 text-sm" data-id="element-90">
              {['El Manual Del Lateral Moderno (5 Capítulos completos)', 'BONO 1: Biblioteca de 30 Ejercicios Específicos', 'BONO 2: Sistema de Autoanálisis Profesional', 'BONO 3: Preparación Física Específica del Lateral', 'BONO 4: Guía para Ganar el Puesto', 'BONO 5: Perfilador de Laterales', 'Calculadora de proteínas', 'Calculadora de hidratación', 'Psicología Deportiva', 'Tabla de validación científica sobre suplementos'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-91">
                  <span className="text-[#84cc16] font-bold" data-id="element-92">✓</span>
                  <span data-id="element-93">{item}</span>
                </li>)}
            </ul>
          </div>

          <p className="text-green-600 font-bold mb-8" data-id="element-94">
            ✓ Todos los bonos GRATIS por hoy
          </p>

          <motion.button whileHover={{
          scale: 1.04,
          y: -2
        }} whileTap={{
          scale: 0.97
        }} transition={{
          type: 'spring',
          stiffness: 400,
          damping: 17
        }} onClick={handleBuy} className="group relative inline-flex items-center justify-center gap-2 overflow-hidden bg-[#84cc16] text-[#14321a] font-bold py-5 px-8 rounded-2xl text-xl md:text-2xl uppercase tracking-wide shadow-[0_10px_30px_-6px_rgba(132,204,22,0.7)] ring-1 ring-[#65a30d]/40 transition-shadow hover:shadow-[0_14px_38px_-4px_rgba(132,204,22,0.85)] w-full" style={{
          fontFamily: 'Anton, sans-serif'
        }} data-id="element-95">
            <span className="pointer-events-none absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:translate-x-full transition-transform duration-700 ease-out" data-id="element-96" />
            <span className="relative z-10" data-id="element-97">QUIERO DOMINAR LA BANDA</span>
            <ArrowRight className="relative z-10 w-6 h-6 transition-transform group-hover:translate-x-1" data-id="element-98" />
          </motion.button>
        </div>
      </div>
    </section>;
}